<template>
  <q-dialog
    v-model="show"
    persistent
    maximized
    clo
    transition-show="slide-up"
    transition-hide="slide-down"
  >
    <q-card>
      <div class="container-persist">
        <div class="close">
          <div style="flex: 1"></div>
          <q-icon
            @click="show = false"
            name="fas fa-times"
            size="50px"
          ></q-icon>
        </div>
        <div class="title">Vehicle Details</div>
        <div id="table-scroll" class="table-scroll" style="margin-bottom: 25px">
          <table id="main-table" class="main-table">
            <thead>
              <tr>
                <th v-for="(col, index) in detail_columns" :key="index">
                  {{ col.name }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td v-for="(col, index) in detail_columns" :key="index">
                  {{ valueSpawner(typeof carDetails[col.val], col.val) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="title">Detailed Future Value Table</div>
        <div id="table-scroll" class="table-scroll">
          <table id="main-table" class="main-table">
            <thead>
              <tr>
                <th v-for="col in columns" :key="col">
                  {{ col }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Projected Mileage</td>
                <td
                  style="min-width:100px"
                  v-for="(val, index) in projected_mileage"
                  :key="index"
                >
                  {{ localeStringConventer(val) }}
                </td>
              </tr>
              <tr>
                <td>Projected Payoff</td>
                <td
                  style="min-width:100px"
                  v-for="(val, index) in projected_payoff"
                  :key="index"
                >
                  {{ currencyConventer(val) }}
                </td>
              </tr>
              <!-- <tr>
                <td>Projected Auction Value</td>
                <td
                  v-for="(val, index) in projected_auction"
                  :key="index"
                  style="min-width:100px"
                >
                  {{ currencyConventer(val) }}
                </td>
              </tr> -->
              <tr>
                <td>Owner Depreciation</td>
                <td
                  v-for="(val, index) in owner_depreciation"
                  :key="index"
                  style="min-width:100px"
                >
                  {{ currencyConventer(val) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style="margin-top: 15px">
          <summary-chart :colors="colors" :items="totalItems"></summary-chart>
        </div>
      </div>
    </q-card>
  </q-dialog>
</template>

<script>
import { Chart } from "highcharts-vue";
import SummaryChart from "./summary/SummaryChart.vue";
import moment from "moment";
export default {
  components: {
    VueHighcharts: Chart,
    SummaryChart,
  },
  props: {
    carDetails: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      colors: ["#003f5c", "#ff6361", "#ffdd00"],
      totalItems: [],
      highchartOption: {
        chart: {
          type: "column",
          style: {
            fontFamily: "Roboto",
          },
        },
        title: {
          text: "",
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          title: {
            text: "",
          },
          labels: {
            formatter: function() {
              return this.value.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
              });
            },
          },
        },
        tooltip: {
          split: true,
          pointFormat:
            '<span style="color:{series.color}">{series.name}</span>: <b>${point.y}</b><br/>',
        },
        colors: ["#003f5c", "#ff6361", "#ffdd00"],
        credits: {
          enabled: false,
        },
        series: [
          {
            name: "Projected Payoff",
            data: [],
          },
          {
            name: "Projected Auction Value",
            data: [],
          },
          {
            name: "Owner Depreciation",
            data: [],
          },
        ],
      },
      projected_mileage: [],
      projected_payoff: [],
      //projected_auction: [],
      owner_depreciation: [],
      columns: [],
      detail_columns: [
        { name: "VIN", val: "vin" },
        { name: "UNIT", val: "unit" },
        { name: "BRAND", val: "brand" },
        { name: "MODEL", val: "model" },
        { name: "MODEL YEAR", val: "model_year" },
        { name: "VEHICLE CLASS", val: "class_name" },
        { name: "LOCATION", val: "location" },
      ],
    };
  },
  methods: {
    _categories() {
      let chart_months = ["Now"];
      let table_months = ["", "Now"];
      for (let index = 1; index < 25; index++) {
        const now = moment();
        const futureMonth = moment(now)
          .add(index, "M")
          .format("MMM Do YY");
        chart_months = [...chart_months, futureMonth];
        table_months = [...table_months, futureMonth];
      }
      //this.highchartOption.xAxis.categories = chart_months;
      //this.totalItems = chart_months;
      this.columns = table_months;
    },
    analyisPusher(months) {
      var titles = [
        "projected_payoff",
        //"projected_auction",
        "owner_depreciation",
      ];
      for (let i = 0; i < titles.length; i++) {
        months.forEach((element) => {
          const j = titles[i];
          if ("projected_payoff" === j) {
            this.highchartOption.series[0].data.push(element?.projected_payoff);
          }
          // else if ("projected_auction" === j) {
          //   this.highchartOption.series[1].data.push(element.projected_auction);
          // }
          if ("owner_depreciation" === j) {
            this.highchartOption.series[2].data.push(
              element?.owner_depreciation
            );
          }
        });
      }
    },
  },

  created() {
    this._categories();
  },
  watch: {
    show(n, o) {
      if (!n) {
        this.projected_mileage = [];
        this.projected_payoff = [];
        this.owner_depreciation = [];
        var titles = [
          "projected_payoff",
          //"projected_auction",
          "owner_depreciation",
        ];
        for (let i = 0; i < titles.length; i++) {
          this.totalItems.forEach((element) => {
            const j = titles[i];
            if ("projected_payoff" === j) {
              this.highchartOption.series[0].data = [];
            }
            // else if ("projected_auction" === j) {
            //   this.highchartOption.series[1].data.push(element.projected_auction);
            // }
            if ("owner_depreciation" === j) {
              this.highchartOption.series[2].data = [];
            }
          });
        }
      }
    },
    vehicle: {
      deep: true,
      handler(n, o) {
        const { current, months } = n;
        if (current && months) {
          //const totals = [].concat(current).concat(months);
          this.totalItems = [current, ...months];
          this.analyisPusher(this.totalItems);
          for (const iterator of this.totalItems) {
            for (const key in iterator) {
              if (key === "owner_depreciation")
                this.owner_depreciation.push(iterator[key]);
              if (key === "projected_mileage")
                this.projected_mileage.push(iterator[key]);
              // else if (key === "projected_auction")
              //   this.projected_auction.push(iterator[key]);
              if (key === "projected_payoff")
                this.projected_payoff.push(iterator[key]);
            }
          }
        }
      },
    },
  },
  computed: {
    valueSpawner() {
      return (type, col_name) => {
        if (type === "object")
          return this.carDetails[col_name] && this.carDetails[col_name].name
            ? this.carDetails[col_name].name
            : "-";
        else return this.carDetails[col_name] ? this.carDetails[col_name] : "-";
      };
    },
    localeStringConventer() {
      return (val) => val.toLocaleString("en-US");
    },
    currencyConventer() {
      return (val) =>
        val.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        });
    },
    vehicle() {
      return this.$store.getters["future/getVehicle"];
    },
    // vehicle: {
    //   get() {
    //     return this.$store.state.future.vehicle;
    //   },
    //   set(val) {
    //     this.$store.commit("future/SET_VEHICLE", val);
    //   },
    // },
    show: {
      get() {
        return this.$store.state.future.show;
      },
      set(val) {
        this.$store.commit("future/SET_SHOW", val);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.center {
  margin: 0 auto;
}
.title {
  font-size: 25px;
  font-weight: 700;
  color: #000;
  flex: 1;
  align-items: center;
  display: flex;
  justify-content: center;
}
.container-persist {
  display: flex;
  flex-flow: column nowrap;
  padding: 15px;
  .close {
    cursor: pointer;
    display: flex;
  }
}
.table-scroll {
  position: relative;
  z-index: 1;
  overflow: auto;
  width: 100%;
  margin-top: 25px;
}
.table-scroll table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
}
.table-wrap {
  position: relative;
}
table,
td,
th {
  border: 1px solid #ccc;
}
.table-scroll {
  th {
    align-items: center;
    padding: 15px 5px;
    background: #fff;
    vertical-align: center;
    text-align: center;
  }
  td {
    font-size: 12px;
    padding: 15px 5px;

    background: #fff;
    vertical-align: center;
    text-align: center;
    cursor: pointer;
  }
}
@media only screen and (max-width: 600px) {
  .table-scroll th,
  .table-scroll td {
    padding: 15px 5px;
    background: #fff;
    vertical-align: center;
    text-align: center;
  }
}
@media only screen and (max-width: 1024px) {
  .container-persist {
    padding: 0 !important;
  }
  .table-scroll {
    position: relative;
    z-index: 1;
    overflow: auto;
    width: 100%;
  }
}
</style>
